import * as classnames from 'classnames';
import * as React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { Dropdown } from 'elc-dropdown';
import { D_T_ID } from '../../constants/DataTestIdAttributes';
import { SHADE_INFO_POSITION_TYPE } from '../../constants/ShadeInfoPositionType';
import { ProductShadeInfo } from './ProductShadeInfo';
import { IStyledShadeIcon, IShadePickerDropdown } from '../../interfaces/IShadePicker';

const StyledShadeIcon = styled.div`
    width: 16px;
    height: 16px;
    background-color: ${({ selectedHexValue }: IStyledShadeIcon) => selectedHexValue};
`;

const StyledDropdown = styled(Dropdown)`
    text-align: left;
    [dir='rtl'] & {
        text-align: right;
    }
`;

const StyledDropdownIcon = styled.div`
    width: 20px;
    height: 20px;
    background-color: ${({ selectedHexValue }: IStyledShadeIcon) => selectedHexValue};
`;

export const ProductShadePickerDropdown = observer((props: IShadePickerDropdown) => {
    const {
        onShadeSelect,
        selectedShade,
        shades,
        className,
        useDropup,
        selectedHexValue,
        hideDropdownArrow,
        productId,
        shadeSettings
    } = props;
    if (!shadeSettings || !shadeSettings.enabled) {
        return null;
    }
    let dropdownOptions: { label: string; value: string }[] = [];
    const handleOnChangeDropDown = (inputName: string, val: string) => {
        if (onShadeSelect) {
            onShadeSelect(val, productId);
        }
    };
    const productShadePickerDropdownClassNames = classnames(
        'elc-product-shade-picker-dropdown',
        'js-product-shade-picker-dropdown',
        className
    );

    const shadeIcon = (hexValue: string) => (
        <StyledShadeIcon
            className="elc-product-shade-picker-dropdown-shade-icon"
            selectedHexValue={hexValue}
        />
    );
    const dropdownIcon = <StyledDropdownIcon selectedHexValue={selectedHexValue} />;

    if (shades && shades.length > 0) {
        dropdownOptions = shades.map(shade => ({
            label: shade.name,
            value: shade.name,
            icon: shadeIcon(shade.hexVal)
        }));
    }

    const shadeNamePosition = shadeSettings && shadeSettings.shadeName;
    const shadeDescriptionPosition = shadeSettings && shadeSettings.shadeDescription;
    const shadeInfoAboveDropdown = shadeNamePosition === SHADE_INFO_POSITION_TYPE.ABOVE;
    const shadeInfoBelowDropdown = shadeNamePosition === SHADE_INFO_POSITION_TYPE.BELOW;
    const shadeInfoInlineDropdown = shadeNamePosition === SHADE_INFO_POSITION_TYPE.INLINE;

    const productShadeInfo = () => {
        return (
            <ProductShadeInfo
                shade={selectedShade}
                descriptionPosition={shadeDescriptionPosition}
                namePosition={shadeNamePosition}
            />
        );
    };

    return (
        <>
            {shadeInfoAboveDropdown && productShadeInfo()}
            <StyledDropdown
                className={productShadePickerDropdownClassNames}
                icon={shadeIcon(selectedHexValue)}
                options={dropdownOptions}
                dropdownIcon={hideDropdownArrow ? dropdownIcon : null}
                name={'shadeNames'}
                selectedValue={selectedShade.name}
                dataTestId={D_T_ID}
                onChange={handleOnChangeDropDown}
                useDropup={useDropup}
            />
            {(shadeInfoInlineDropdown || shadeInfoBelowDropdown) && productShadeInfo()}
        </>
    );
});
